import { useExtendWithSubnetworks } from "@l2r-front/l2r-networks"

import { API_MODULE_ROADWAY } from "../../../../../common/constants/appRoad"
import { useRoadQuery } from "../../../../../common/hooks/queries/useRoadQuery"

import { networkGradingsQueryKeys } from "./queryKeys"

export function useListNetworkGradings(queryParameters, config = {}) {
    const url = "network_gradings/"

    const parameters = useExtendWithSubnetworks({ ...queryParameters }, API_MODULE_ROADWAY)
    const queryKey = [...networkGradingsQueryKeys["list"](parameters)]

    return useRoadQuery(
        url,
        queryKey,
        parameters,
        config,
    )
}